import type { AppProps } from "next/app";
import { AppProvider as PolarisProvider } from "@shopify/polaris";
import { AppProvider } from "../providers/app";
import "@shopify/polaris/build/esm/styles.css";
import "~/app.css";

const App = ({ Component, pageProps }: AppProps) => {
  return (
    <PolarisProvider i18n={{}}>
      <AppProvider>
        <Component {...pageProps} />
      </AppProvider>
    </PolarisProvider>
  );
};

export default App;
